import { apiClient } from 'api'
import { Player } from 'types'

type NewItem = Omit<Player, 'id' | 'position' | 'playersToPlayersRatings' | 'playersToTeams'>

export const getPlayers = () => apiClient.get<Player[]>('/players')

export const getPlayerById = (playerId: number) => apiClient.get<Player>(`/players/${playerId}`)

export const createPlayer = (player: NewItem) => apiClient.post<NewItem, Player>('/players', player)

export const editPlayer = (player: Player) => apiClient.patch<Player>(`/players/${player.id}`, player)

export const deletePlayer = (id: number) => apiClient.delete(`/players/${id}`)
